import React from "react";
import { getIcons } from "../components/Constant/Constant";

export const getBackgroundClass = (label) => {
  switch (label.toLowerCase()) {
    case "gold":
      return "bg-gradient-to-b from-[#FFB947] to-[#ECCD90] bg-clip-text text-transparent";
    case "silver":
      return "bg-gradient-to-b from-[#B6B6B6] to-[#E8E8E8] bg-clip-text text-transparent";
    case "bronze":
      return "bg-gradient-to-b from-[#BA7E5E] via-[#FF9F6B] to-[#411904] bg-clip-text text-transparent";
    case "diamond":
      return "bg-gradient-to-b from-[#0563FF] to-[#4085F8] bg-clip-text text-transparent";
    default:
      return "bg-gradient-to-b from-red-500 to-[#4085F8] bg-clip-text text-transparent";
  }
};

export const getStatusBgColor = (label) => {
  switch (label) {
    case "Fresh":
      return "bg-[#74F2C433] border-2 border-[#399E79]";
    case "Registered Client":
      return "bg-[#2280FF1A] border-2 border-[#2280FF]";
    case "Follow-up":
      return "bg-[#D2FAEC80] border-2 border-[#399E79]";
    case "Deal Lost":
      return "bg-[#FDB1B140] border-2 border-[#FDB1B1]";
    case "Not Interested":
      return "bg-[#FFBFA44D] border-2 border-[#FFBFA4]";
    case "Unanswered":
      return "bg-[#FFBFA44D] border-2 border-[#FFBFA4]";
    case "Retry Suitable":
      return "bg-[#74F2C433] border-2 border-[#399E79]";
    case "Call Back":
      return "bg-[#FFFEDE80] border-2 border-[#FFF4B5]";
    case "Response":
      return "bg-[#2280FF1A] border-2 border-[#98DDFF]";
    case "Junk":
      return "bg-red-100 border-2 border-red-300";
    default:
      return "bg-[#74F2C433] border-2 border-[#399E79]";
  }
};

export const interestLevel = [
  {
    value: "YkC7pUhxKKURN7AZjDhl",
    label: "Diamond",
    image: getIcons().diamond,
  },
  {
    value: "80OWCT8bC9H25c4lt83r",
    label: "Gold",
    image: getIcons().gold,
  },
  {
    value: "lIOauRSITzlqtQ3WwctM",
    label: "Silver",
    image: getIcons().silver,
  },
  {
    value: "N3ZumYbY3xL2II1Pajco",
    label: "Bronze",
    image: getIcons().bronze,
  },
  {
    value: "YU7CUTChnFR6vsKf0VWW",
    label: "Not Applicable",
    image: getIcons().NAEmoji,
  },
];

export const leadStatusList = [
  {
    label: "Fresh",
    value: "Fresh",
    image: getIcons().freshIcon,
  },
  {
    label: "Registered Client",
    value: "Registered Client",
    image: getIcons().registeredClient,
  },
  {
    label: "Call Back",
    value: "Call Back",
    image: getIcons().CallBack,
  },
  {
    label: "Response",
    value: "Response",
    image: getIcons().Response,
  },
  {
    label: "Follow-up",
    value: "Follow-up",
    image: getIcons().interestedIcon,
  },
  {
    label: "Deal Lost",
    value: "Deal Lost",
    image: getIcons().dealLostIcon,
  },
  {
    label: "Not Interested",
    value: "Not Interested",
    image: getIcons().notInterestedIcon,
  },
  {
    label: "Unanswered",
    value: "Unanswered",
    image: getIcons().unansweredIcon,
  },
  {
    label: "Retry Suitable",
    value: "Retry Suitable",
    image: getIcons().RetrySuitable,
  },
  {
    label: "Dealing",
    value: "Dealing",
    image: getIcons().dealingIcon,
  },
];

// L0CTrn0qwWlHWvq2gXDm: { label: "Assigned Fresh", color: "#EBEBFF" },
// Auf9SQFhiKF7WRM9ZiTA: { label: "Follow-up", color: "#E3F3FC" },
// gJxbL16EjFbzDFCoQU5G: { label: "Dealing", color: "#D6F3EA" },
// znvixWClH1PDoCXO4Aat: { label: "Registered Client", color: "#8BDBBE" },
// "8337Bve50LqwfrkveUrY": { label: "Deal Lost", color: "#D8FFE0" },
// yUuWlPRZEosdOeLzyL0f: { label: "Unanswered", color: "#FBE7E5" },
// VH26wB3VgVXBzoBJiqml: { label: "Not Interested", color: "#FBE7E5" },
// PdCEXW0VIoVviuqvjdWc: { label: "Retry Suitable", color: "#B1C8F5" },
// "9XSuBds8XzEmvVNDr3yr": { label: "Junk", color: "#8BDBBE" },

export const statusImage = {
  "Registered Client": getIcons().customerIcon,
  Fresh: getIcons().freshIcon,
  Dealing: getIcons().dealingIcon,
  "Deal Lost": getIcons().dealLostIcon,
  "Follow-up": getIcons().interestedIcon,
  "Retry Suitable": getIcons().RetrySuitable,
  "Not Interested": getIcons().notInterestedIcon,
  Unanswered: getIcons().unansweredIcon,
  Junk: getIcons().Junk,
  "Call Back": getIcons().CallBack,
  Response: getIcons().Response,
};

export const leadCharacter = {
  "Not Applicable": getIcons().NAEmoji,
  Excited: getIcons().excitedEmoji,
  Neutral: getIcons().neutralEmoji,
  Confused: getIcons().confusedEmoji,
  Thinking: getIcons().ThinkingEmoji,
  None: getIcons().NAEmoji,
};

export const statusIcons = Object.freeze([
  {
    value: "L0CTrn0qwWlHWvq2gXDm",
    label: "Fresh",
    image: getIcons().freshIcon,
  },
  {
    value: "znvixWClH1PDoCXO4Aat",
    label: "Registered Client",
    image: getIcons().registeredClient,
  },

  {
    value: "ZCjUyJXo9KDBmdnlmWVq",
    label: "Call Back",
    image: getIcons().CallBack,
  },
  {
    value: "Wx3ErE2NkJPooQT06Sm9",
    label: "Response",
    image: getIcons().Response,
  },

  {
    value: "Auf9SQFhiKF7WRM9ZiTA",
    label: "Follow-up",
    image: getIcons().interestedIcon,
  },
  {
    value: "8337Bve50LqwfrkveUrY",
    label: "Deal Lost",
    image: getIcons().dealLostIcon,
  },
  {
    value: "VH26wB3VgVXBzoBJiqml",
    label: "Not Interested",
    image: getIcons().notInterestedIcon,
  },
  {
    value: "yUuWlPRZEosdOeLzyL0f",
    label: "Unanswered",
    image: getIcons().unansweredIcon,
  },
  {
    value: "PdCEXW0VIoVviuqvjdWc",
    label: "Retry Suitable",
    image: getIcons().RetrySuitable,
  },
  {
    value: "gJxbL16EjFbzDFCoQU5G",
    label: "Dealing",
    image: getIcons().dealingIcon,
  },
]);

export const status = [
  "Fresh",
  "Follow-up",
  "Dealing",
  "Registered Client",
  "Unanswered",
  "Not Interested",
  "Deal Lost",
  "Retry Suitable",
  "Junk",
  "Call Back",
  "Response",
];

// "leadCharacter/auGmm0doKy3uX83ymb6B": "Not Applicable",
//     "leadCharacter/awJIcuGjLpIKN74669Ld": "Excited",
//     "leadCharacter/eYyXBA3h03KAu4WiuHHX": "Neutral",
//     "leadCharacter/hgVWDu1yV2YhMHqs8c6f": "Confused",
//     "leadCharacter/pgo2FCG8PJAA42I58dEi": "Thinking",

export const leadCharacterEmoji = Object.freeze([
  {
    value: "auGmm0doKy3uX83ymb6B",
    label: "Not Applicable",
    image: getIcons().NAEmoji,
  },
  {
    value: null,
    label: "None",
    image: getIcons().NAEmoji,
  },
  {
    value: "awJIcuGjLpIKN74669Ld",
    label: "Excited",
    image: getIcons().excitedEmoji,
  },
  {
    value: "eYyXBA3h03KAu4WiuHHX",
    label: "Neutral",
    image: getIcons().neutralEmoji,
  },
  {
    value: "pgo2FCG8PJAA42I58dEi",
    label: "Thinking",
    image: getIcons().ThinkingEmoji,
  },
  {
    value: "hgVWDu1yV2YhMHqs8c6f",
    label: "Confused",
    image: getIcons().confusedEmoji,
  },
]);
